import {useIsDebug} from "../../index";
import {useMemo} from "react";

export default function useAnimationDebug(forceDebug){
    const queryDebug = useIsDebug()
    return useMemo(() => forceDebug || queryDebug, [forceDebug, queryDebug])
}
